<template>
	<div class="Following-box">
		<div class="Following-box_header">
			<h2 class="title">{{ $t('FollowersArr.Followers') }} <span class="list_length" v-if="list && list.length > 0">( {{list.length}} )</span></h2>
			<!-- <div class="search_box">
			  <input class="search_input" aria-label="Search for recommenders" v-model="search.user_name" type="text" :placeholder="placeholder" />
			  <div class="el-icon-search-box" :class="icon_search ? '' : 'close_box'" @click="clear_search_input()">
					<i class="el-icon-search" v-if="icon_search"></i>
					<i class="el-icon-close" v-else></i>
				</div>
			</div> -->
		</div>
		
		<div class="content_box" v-if="Loading">
			<Loading></Loading>
		</div>
		<div class="content_box" v-else>
			<FanFollowList v-if="loading_completed" :Fan_Follow_List="list" :parent_type="parent_type" @modify_state="modify_state"></FanFollowList>
			<Pagination v-show="total_num > 0" :per_page.sync="search.per_page" :page-sizes="pageSizes" :page.sync="search.page" :total="total_num" @pagination="get_page_Data" ></Pagination>
		</div>
		
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import FanFollowList from '../components/public/FanFollowList.vue'
import { post_community_userfocus } from '@/api/community.js'
import Pagination from "@/components/Pagination"

export default {
	name: 'follow-list',
	components: { FanFollowList, Pagination },
	
	data() {
		return {
			parent_type: "follow-list",
			placeholder: this.$t('FollowingArr.Search_for_Followers'),
			searchText: "",
			currentFirst: true,
			icon_search: true,
			search: {
				user_id: this.$store.state.userinfo.user_id,
				user_name: '',
				page: 1,
				per_page: 20,
			},
			list:[],
			Loading: false,
			loading_completed: false,
			total_num: 0,
			last_page: 0,
			pageSizes: [10, 20, 30],
		}
	},
	
	computed: {
	   ...mapGetters(['getFanFollowerStatus']), // 映射 Vuex 的 getter
	},
	
	// 监听
	watch: {
		"$store.state.userinfo": {
			handler: function (newValue, oldValue) {
				this.search.user_id = this.$store.state.userinfo.user_id
			},
			deep: true
		},
		"search.user_name": {
			handler: function (newValue, oldValue) {
				if(this.search.user_name && this.search.user_name != ''){
					this.icon_search = false
				}else{
					this.icon_search = true
				}
				this.search.page = 1
				this.get_data_list()
			},
			deep: true
		},
		getFanFollowerStatus(newValue, oldValue) {
         // 监听状态的变化
         if (newValue.value == 'success') {
               console.log('获取成功');
					this.get_data_list(this.currentFirst ? '' : 'HiddeLoading')
            } else {
               console.log('获取失败');
         }
      },
		// "$store.state.fan_follower_status": {
		// 	handler: function (newValue, oldValue) {
		// 		if(newValue.value == 'success'){
		// 		this.get_data_list(this.currentFirst ? '' : 'HiddeLoading')
		// 		}
		// 	},
		// 	deep: true
		// },
		
	},
	
	// beforeCreate() {
		
	// }
	
	beforeRouteLeave(to, from, next) {
		console.log('路由正在离开粉丝列表页面');
	   next();
	},
	
	// 路由进入可操作数据
	activated() {
		console.log('路由进来粉丝列表页面成功返回');
		this.get_data_list(this.currentFirst ? '' : 'HiddeLoading')
		this.$setTags.updateMetaDescription("TOZO Community follow list")
		// this.set_type_list()
	},
	
	created () {
	  
	},
  
	mounted() {
		this.get_data_list(this.currentFirst ? '' : 'HiddeLoading')
		this.$setTags.updateMetaDescription("TOZO Community follow list")
	},
  
	methods:{
		// 获取分页
		get_page_Data(obj) {
			console.log(obj)
			this.search.page = obj.page
			if(obj.per_page){
				this.search.per_page = obj.per_page
			}
			this.get_data_list()
		},
		
		//获取列表
		get_data_list(typeName){
			if(!this.search.user_id){ 
				this.loading_completed = true
				return
			}
			if(this.Loading){ return }
			if(typeName != "HiddeLoading"){
				this.Loading = true
				this.loading_completed = false
			}
			this.currentFirst = false
			let obj = {
				user_id: this.search.user_id, 
				user_name: this.search.user_name, 
				page: this.search.page,
				per_page: this.search.per_page
			}
			console.log(obj)
			post_community_userfocus(obj)
		   .then((res) => {
				console.log(res)
				if(res.code == 0){
					this.list = res.data.data
					this.total_num = res.data.total ? res.data.total : 0
					this.last_page = res.data.last_page ? res.data.last_page : 0
				}else{
					this.exception_handling(res)
				}
				
				let path = this.$router.currentRoute.path
				this.$setTags.updateCanonical(`${path}?page=${obj.page || 1}`)
				// this.$setTags.updateCanonical(`/follow-list?page=${obj.page || 1}`)
				this.Loading = false
				this.loading_completed = true
		   })
		   .catch((err) => {
				console.log(err)
				this.exception_handling(err)
		   })
		},
		
		//异常处理
		exception_handling(err){
			this.list = []
			this.Loading = false
			this.total_num = 0
			this.last_page = 0
			this.$errorMessage(err)
			// this.$message('err.data.message', 'error')
		},
		
		//取消/关注/删除
		modify_state(type){
			if(type == 'success'){
				this.get_data_list('HiddeLoading')
			}
		},
		
		//清空输入框
		clear_search_input() {
			if(!this.icon_search){
				this.search.user_name = "";
			}
		},
  }
}
</script>

<style lang="less" scoped>
	*{
		box-sizing: border-box;
		font-family: Poppins, Poppins;
	}
	.search_input::placeholder {
	    color: #B3B3B3;
	}
	.el-icon-search-box{
		width: 40px;
		height: 40px;
		position: absolute;
		top: 0;
		right: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #B3B3B3;
		
	}
	.close_box{
		cursor: pointer;
	}
	.Following-box{
		border-radius: 8px;
	}
	@media screen and (min-width: 1024px) {
		.Following-box_header{
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 10px 0px;
			.title{
				font-weight: 400;
				font-size: 18px;
				color: #000000;
				line-height: 1;
				text-align: left;
				font-style: normal;
				text-transform: none;
			}
		}
		.Following-box {
			width: 100%;
			padding: 10px 10px;
			background-color: #ffffff;
		}
		.search_box{
			width: calc(100% - 120px);
			max-width: 280px;
			position: relative;
		}
		.search_input{
			width: 100%;
			height: 40px;
			border-radius: 20px;
			background: #FFFFFF;
			padding: 0px 40px 0px 13px;
			border: 1px solid #D9D9D9;
			font-family: Poppins, Poppins;
			font-weight: 400;
			font-size: 14px;
			color: #505050;
			line-height: 16px;
			text-align: left;
			font-style: normal;
			text-transform: none;
		}
		.el-icon-search,
		.el-icon-close{
			font-size: 16px;
		}
		.content_box{
			margin-top: 28px;
		}
	}
	@media screen and (max-width: 1024px) {
		.Following-box_header{
			width: 100%;
			display: flex;
			flex-direction: column;
			padding: 10px 0px;
			.title{
				font-weight: 400;
				font-size: 14px;
				color: #000000;
				line-height: 1;
				text-align: left;
				font-style: normal;
				text-transform: none;
			}
		}
		.Following-box {
			width: 100%;
			padding: 10px 10px;
			background-color: #ffffff;
		}
		.search_box{
			margin-top: 20px;
			width: calc(100% - 0px);
			max-width: 100%;
			position: relative;
		}
		.search_input{
			width: 100%;
			height: 38px;
			border-radius: 20px;
			background: #FFFFFF;
			padding: 0px 40px 0px 13px;
			border: 1px solid #D9D9D9;
			font-family: Poppins, Poppins;
			font-weight: 400;
			font-size: 14px;
			color: #505050;
			line-height: 16px;
			text-align: left;
			font-style: normal;
			text-transform: none;
		}
		.el-icon-search,
		.el-icon-close{
			font-size: 14px;
		}
		.content_box{
			margin-top: 20px;
		}
	}
</style>
